import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function LoadingPlaceholder({ style, ...rest }) {
    return (
        <div style={{ display: "flex", justifyContent: "center", overflow: "hidden", ...style }} {...rest}>
            <CircularProgress style={{ maxWidth: "100%", maxHeight: "100%" }} />
        </div>
    );
}
